/* VECTORS */
export const GET_VECTORS = "GET_VECTORS"
export const GET_VECTORS_SUCCESS = "GET_VECTORS_SUCCESS"
export const GET_VECTORS_FAIL = "GET_VECTORS_FAIL"


/* GET_VECTOR_DETAIL */
export const GET_VECTOR_DETAIL = "GET_VECTOR_DETAIL"
export const GET_VECTOR_DETAIL_SUCCESS = "GET_VECTOR_DETAIL_SUCCESS"
export const GET_VECTOR_DETAIL_FAIL = "GET_VECTOR_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add VECTOR
 */
 export const ADD_NEW_VECTOR = "ADD_NEW_VECTOR"
 export const ADD_VECTOR_SUCCESS = "ADD_VECTOR_SUCCESS"
 export const ADD_VECTOR_FAIL = "ADD_VECTOR_FAIL"
 
 /**
  * Edit VECTOR
  */
 export const UPDATE_VECTOR = "UPDATE_VECTOR"
 export const UPDATE_VECTOR_SUCCESS = "UPDATE_VECTOR_SUCCESS"
 export const UPDATE_VECTOR_FAIL = "UPDATE_VECTOR_FAIL"
 
 /**
  * Delete VECTOR
  */
 export const DELETE_VECTOR = "DELETE_VECTOR"
 export const DELETE_VECTOR_SUCCESS = "DELETE_VECTOR_SUCCESS"
 export const DELETE_VECTOR_FAIL = "DELETE_VECTOR_FAIL"
 

